import { Atividades } from '../../components/Atividade'



export function Home(){

    return(
        <Atividades />
    )
}